export default "__VITE_ASSET__CbX41WYZ__"